export default "__VITE_ASSET__BRdNFIvl__";